import React from "react";
import ItemDetailViewSection, {
  Item,
} from "../../../common/item/ItemDetailViewSection";
import { Data } from "../../../store/processor/types";

interface ProcessorViewDetail {
  processorData: Data;
}

const ProcessorViewDetail = (props: ProcessorViewDetail) => {
  const { attributes: at } = props.processorData;

  const processorInfo: Item[] = [
    { fieldName: "Processor Name", fieldValue: at.Name },
    { fieldName: "FIIC", fieldValue: at.FIIC as string },
    { fieldName: "Host", fieldValue: at.Host },
    { fieldName: "Port", fieldValue: at.Port },
    {
      fieldName: "Maintain Transaction Sequence",
      fieldValue: at.MaintainTransactionSequence,
    },
  ];

  return (
    <ItemDetailViewSection
      sectionName="Processor Info"
      itemData={processorInfo}
      binProcesors={at.Bin}
      lastItem
    />
  );
};

export default ProcessorViewDetail;
